"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _form = require("@clayui/form");
var _react = _interopRequireDefault(require("react"));
var _Context = require("./Context");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); } /**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ClayAutocompleteInput = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _React$useContext = _react.default.useContext(_Context.LegacyContext),
    loading = _React$useContext.loading;
  return /*#__PURE__*/_react.default.createElement(_form.ClayInput, _extends({}, props, {
    insetAfter: loading,
    ref: ref
  }));
});
ClayAutocompleteInput.displayName = 'ClayAutocompleteInput';
var _default = exports.default = ClayAutocompleteInput;